<template>
  <div class="box">
    <!-- Header with search -->
    <div class="level">
      <div class="level-left">
        <div class="level-item">
          <h3 class="title">
            Recent Applications
          </h3>
        </div>
      </div>
      <div class="level-right">
        <div class="level-item">
          <div
            class="field"
            style="min-width: 300px;"
          >
            <textbox
              v-model="searchTerm"
              placeholder="Search by address or EDP #..."
              icon="fas fa-search"
              :inner-label="false"
            />
          </div>
        </div>
        <div class="level-item">
          <button
            class="button is-primary"
            @click="handleAddApplication"
          >
            <span class="icon">
              <i class="fas fa-plus" />
            </span>
            <span>Add Application</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Table -->
    <div class="table-container">
      <table class="table is-fullwidth is-hoverable">
        <thead>
          <tr>
            <th>EDP #</th>
            <th>Address</th>
            <th>Primary Tenant</th>
            <!-- <th>Bank Account</th> -->
            <th>Pathway</th>
            <th>Application Status</th>
            <th>Status Details</th>
            <th> Resubmission Required?</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="application in filteredApplications"
            :key="application.id"
            style="cursor: pointer;"
            @click="handleRowClick(application)"
          >
            <td><strong>{{ application.edp_number }}</strong></td>
            <td>{{ application.unit_address_street_1 }} {{ application.unit_address_street_2 }}</td>
            <td>{{ application.tenant_full_name }}</td>
            <!-- <td >{{ application.bank_name }} {{ application.bank_number }}</td> -->
            <td>{{ application.pathway_name }}</td>
            <td>
              <span
                class="tag is-rounded"
                :style="{
                  backgroundColor: getApplicationStatusInfo(application.application_status).bgColor,
                  color: getApplicationStatusInfo(application.application_status).color,
                  fontWeight: 600,
                }"
              >
                {{ getApplicationStatusInfo(application.application_status).label }}
              </span>
            </td>
            <td><a :href="`/Status/${application.edp_number}`" target="_blank" class="button is-primary is-small">View Status</a></td>
            <td>
              <a
                v-if="shouldShowResubmit(application)"
                :href="getResubmitUrl(application)"
                target="_blank"
                class="button is-primary"
                @click.stop
              >
                Resubmit
              </a>
              <span
                v-else
                class="medium-gray"
              >-</span>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- No results message -->
      <div
        v-if="filteredApplications.length === 0"
        class="has-text-centered"
        style="padding: 3rem;"
      >
        <p class="medium-gray">
          <i
            class="fas fa-inbox fa-3x"
            style="color: #cfcfcf; margin-bottom: 1rem;"
          /><br>
          No applications found
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { getApplicationStatusInfo, filterApplications } from "@/utilities/dashboard";

export default {
  name: "ApplicationsTable",
  data() {
    return {
      searchTerm: "",
    };
  },
  computed: {
    filteredApplications() {
      if (!this.searchTerm) {
        return this.applications;
      }
      return filterApplications(this.searchTerm,this.applications);
    },
    applications(){
      return this.$store.getters['dashboard/applications'];
    },
  },
  methods: {
    getApplicationStatusInfo,
    handleRowClick(application) {
      console.log("Row clicked:", application);
      this.$emit("row-click", application);
    },
    shouldShowResubmit(application) {
      return application.resubmit_status &&
             application.resubmit_status.includes('Awaiting Resubmission');
    },
    getResubmitUrl(application) {
      if (application.resubmit_status && application.resubmit_status.includes('TFA')) {
        return application.tfa_resubmit_url;
      }
      return application.resubmit_url;
    },
    handleAddApplication() {
      const route = this.$router.resolve({
        name: "LandlordApplicationLargeFiler",
      });
      window.open(route.href, '_blank');
    },
  },
};
</script>

<style scoped>
.box {
  padding: 0.75rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.medium-gray {
  color: #a1a1a1; /* Medium Gray - Philly Style Guide */
}
</style>
